import { Link, LinkProps } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { localizePath } from '../i18n/config';

/**
 * LocalizedLink — 自动为链接添加当前语言前缀。
 * 用法与 react-router 的 <Link> 完全一致。
 * 例：中文环境下 <LocalizedLink to="/products"> 实际跳转到 /zh/products
 */
export function LocalizedLink(props: LinkProps) {
  const { i18n } = useTranslation();
  const localizedTo =
    typeof props.to === 'string' ? localizePath(props.to, i18n.language) : props.to;

  return <Link {...props} to={localizedTo} />;
}
